import * as d3 from "d3";
import { Chart } from "@/utils/Chart";
import i18n from "../lang/lang";

export function ChartBarSimpleHorizontal(alias, chartData) {
  // Se resive el alias y los datos
  // Revisar el componente CardChartIndicator, este se encarga de saber que tipo de gráfica mostrar
  this.alias = alias;
  this.chartData = chartData;
  this.data = chartData.data;
  this.percentage = false;
  var chart = new Chart(alias); // Usa la clase base
  this.render = function () {
    var x = d3
      .scaleLinear()
      .range([0, chart.chartWidth])
      .domain([
        0,
        Math.max(1,d3.max(this.data, (d) => {
          if (d.type === "percentage") {
            this.percentage = true;
            return d.percentage;
          } else {
            return d.value;
          }
        })),
      ]);

    var y = d3
      .scaleBand()
      .domain(
        this.data.map(function (d) {
          return i18n.tc(d.label);
        })
      )
      .rangeRound([0, chart.chartHeight])
      .padding(0.3);

    var bar = chart.svg.selectAll(".bar").data(this.data);

    // append rects
    var rect = bar
      .enter()
      .append("rect")
      .attr("class", "bar")
      .style("fill", (d) => {
        return chart.getColor(d.label);
      })
      .attr("y", function (d) {
        return y(i18n.tc(d.label));
      })
      .attr("height", y.bandwidth())
      .attr("x", 0)
      .attr("width", 0)
      .on("mouseover", function (d) {
        // Esto es lo que nos permite mostrar los tooltip
        // A continuación se muestra como se debe usar el metodo para formatear el texto
        // el i18.tc nos sirve para tener las traducciones en las graficas
        chart.openTooltip(chart.format(d, true) + " " + i18n.tc(d.label));
      })
      .on("mouseout", function () {
        chart.closeTooltip();
      })
      .on("mousemove", function () {
        var coordinates = d3.mouse(this);
        chart.moveTooltip(coordinates[0], coordinates[1]);
      });
    rect
      .transition(chart.transition)
      .attr("width", function (d) {
        if (d.type === "percentage") {
          return x(d.percentage);
        } else {
          return x(d.value);
        }
      })
      .attr("x", 0);

    // add a value label to the right of each bar
    var text = chart.svg
      .selectAll("text")
      .data(this.data)
      .enter()
      .append("text")
      .attr("x", 0)
      .attr("y", function (d) {
        return y(i18n.tc(d.label)) + y.bandwidth() / 2;
      })
      .attr("dx", "0.3rem")
      .style("font-size", chart.fontSize)
      .style("font-family", "Oswald-Light")
      .text(function (d) {
        return chart.format(d);
      });

    text.transition(chart.transition).attr("x", function (d) {
      if (d.type === "percentage") {
        return x(d.percentage);
      } else {
        return x(d.value);
      }
    });
    // se llama al metodo encargado de dibujar los ejes
    chart.drawAxis(
      x,
      y,
      this.chartData.xAxis,
      this.chartData.yAxis,
      this.percentage
    );
  };
}
